import { render, staticRenderFns } from "./AutocompleteMaterial.vue?vue&type=template&id=64dd48a9&"
import script from "./AutocompleteMaterial.vue?vue&type=script&lang=js&"
export * from "./AutocompleteMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports